export default __webpack_public_path__ + "static/taken-bf4d60b98ad60afd6f74a18daeb36e1e.svg";